import { Donor } from 'src/api/Donor';
import apiClient from './core/ApiClient'
import { DonorListResponse } from 'src/api/DonorListResponse';
import { DonorListQuery } from 'src/api/DonorListQuery';
import { DonorDetailResponse } from 'src/api/DonorDetailResponse';
import { DonorStoreRequest } from 'src/api/DonorStoreRequest';
import { StoreResponse } from 'src/api/StoreResponse';

const path = '/api/donations/donors';

const list = (query: DonorListQuery): Promise<DonorListResponse> => {
    const params = new URLSearchParams({
        page: String(query.page),
        pageSize: String(query.pageSize),
        sortDirection: query.sortDirection as string,
    });

    if (query.search) params.set('search', query.search);
    if (query.kinds.length) params.set('kind', query.kinds.join(','));
    if (query.statuses.length) params.set('status', query.statuses.join(','));
    if (query.sortBy) params.set('sortBy', query.sortBy);

    return apiClient.get<DonorListResponse>(`${path}?${params.toString()}`);
};

const find = (id: number): Promise<DonorDetailResponse> => apiClient.get<DonorDetailResponse>(`${path}/${id}`);

const create = (donor: DonorStoreRequest): Promise<StoreResponse> =>
    apiClient.post<DonorStoreRequest, StoreResponse>(path, donor);

const update = (id: number, donor: DonorStoreRequest): Promise<void> =>
    apiClient.put<DonorStoreRequest, void>(`${path}/${id}`, donor);

const archive = (id: number): Promise<void> => apiClient.delete<void>(`${path}/${id}`);

export const donorService = {
    list,
    find,
    create,
    update,
    archive,
}
